export const Spacing = {
  DesktopWide: '110px',
  Desktop: '80px',
  Tablet: '30px',
}
